import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import axios from "axios";
import Card from "../../components/Card/Card";
import { RxDashboard } from "react-icons/rx";
import { useNavigate } from "react-router";
import Expenses from "../../components/Expenses/Expenses";
import Sidemenu from "../../components/Sidemenu/Sidemenu";
import AddExpense from "../../components/Expenses/AddExpense/AddExpense";
import { useExpenses } from "../../contexts/expenses.context";
import { useDashboard } from "../../contexts/dashboard.context";
import AddIncome from "../../components/Incomes/AddIncome/AddIncome";
import Incomes from "../../components/Incomes/Incomes";
import { useIncomes } from "../../contexts/incomes.context";
import {
  getUserAPI,
  getUserExpenses,
  getUserIncome,
} from "../../utils/apiCalls";
import PersonalInfo from "../../components/PersonalInfo/PersonalInfo";

interface TokenType {
  exp: number;
  iat: number;
  id: string;
}

interface UserInfoType {
  email: string;
}

const Dashboard = () => {
  const { totalExpenses, addArrayExpenses } = useExpenses();
  const { totalIncome, addArrayIncomes } = useIncomes();
  const { page } = useDashboard();
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState<UserInfoType | undefined>(undefined);
  const [tokenDecoded, setTokenDecoded] = useState<TokenType | undefined>(
    undefined
  );

  useEffect(() => {
    const token = Cookies.get("token");

    if (!token) {
      navigate("/");
      return;
    }

    const decodedToken: TokenType = jwtDecode(token);
    setTokenDecoded(decodedToken);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (tokenDecoded?.id) {
        try {
          const [userData, expensesData, incomeData] = await Promise.all([
            getUserAPI(tokenDecoded.id),
            getUserExpenses(tokenDecoded.id),
            getUserIncome(tokenDecoded.id),
          ]);

          setUserInfo(userData);
          addArrayExpenses(expensesData);
          addArrayIncomes(incomeData);
        } catch (error) {
          console.error("Error fetching data", error);
        }
      }
    };

    fetchData();
  }, [tokenDecoded]);

  return userInfo && tokenDecoded?.id ? (
    <>
      <div className="flex flex-row items-center gap-2 mt-10 mb-6">
        <RxDashboard color="#909090" size={16} />
        <p className="text-light-gray font-inter">Dashboard</p>
      </div>
      <div className="grid grid-cols-4 gap-8 mb-8 animate-cardSlideTop">
        <Card
          text="Total"
          value={Number("8945").toLocaleString("en-US", {
            style: "currency",
            currency: "EUR",
          })}
        />
        <Card text="Growth Yearly (%)" value="76%" />
        <Card
          text="Montly savings"
          value={Number(totalIncome - totalExpenses).toLocaleString("en-US", {
            style: "currency",
            currency: "EUR",
          })}
        />
        <Card
          text="Fixed expenses"
          value={Number(totalExpenses).toLocaleString("en-US", {
            style: "currency",
            currency: "EUR",
          })}
        />
      </div>
      <hr className="border-almost-white" />
      <div className="grid grid-cols-4 gap-8 mt-8">
        <div className="col-span-1">
          <Sidemenu />
        </div>
        <div className={page === "MainData" ? "col-span-3" : "col-span-1"}>
          {(() => {
            switch (page) {
              case "Expenses":
                return <AddExpense userId={tokenDecoded.id} />;
              case "Income":
                return <AddIncome userId={tokenDecoded.id} />;
              case "MainData":
                return <PersonalInfo />;
              default:
                return undefined;
            }
          })()}
        </div>

        <div className="col-span-2">
          {(() => {
            switch (page) {
              case "Expenses":
                return <Expenses />;
              case "Income":
                return <Incomes />;
              default:
                return undefined;
            }
          })()}
        </div>
      </div>
    </>
  ) : (
    <div>Loading...</div>
  );
};

export default Dashboard;
